import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import albumReducer from "./slices/albumSlice";
import vacancyReducer from "./slices/vacancySlice";
import messageReducer from "./slices/messageSlice";
import employeeReducer from "./slices/employeeSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    album: albumReducer,
    vacancy: vacancyReducer,
    message: messageReducer,
    employee: employeeReducer,
  },
});
